module.exports = __webpack_public_path__ + "static/brian-8308f1780dc0b9f40daeaa6109881a3d.png";